import { GroupResource, GroupViewModel } from '@/models'

export function transformGroupResource(group: GroupResource): GroupViewModel {
    return {
        id: group.id,
        name: group.name,
    }
}
